import { jsx as _jsx } from "react/jsx-runtime";
import { useMemberPosts } from '@tribeplatform/react-sdk/hooks';
import { simplifyPaginatedResult } from '@tribeplatform/react-sdk/utils';
import { EmptyState } from './EmptyState';
import { GenericPostList } from './GenericPostList';
export const MemberPostList = ({ memberId, hasParent = false, view }) => {
    const { data, fetchNextPage = false, hasNextPage, isLoading, isFetched, isFetchingNextPage, } = useMemberPosts({
        variables: { limit: 5, memberId, hasParent },
        useInfiniteQueryOptions: {
            refetchOnMount: 'always',
        },
        fields: {
            tags: 'basic',
            owner: {
                member: { profilePicture: 'basic', badges: 'all' },
            },
            embeds: 'basic',
            mentions: 'basic',
            space: {
                authMemberProps: 'all',
                image: 'basic',
            },
            attachments: 'basic',
            authMemberProps: 'all',
            repliedTos: hasParent ? 'basic' : null,
            reactions: { fields: 'all', variables: { limit: 10 } },
            replies: hasParent
                ? null
                : {
                    fields: {
                        authMemberProps: 'all',
                        embeds: 'basic',
                        mentions: 'basic',
                        attachments: 'basic',
                        owner: {
                            member: { profilePicture: 'basic', badges: 'all' },
                        },
                        reactions: { fields: 'all', variables: { limit: 10 } },
                    },
                    variables: {
                        limit: 2,
                        reverse: true,
                    },
                },
        },
    });
    const { nodes: posts } = simplifyPaginatedResult(data);
    if (!isLoading && !(posts === null || posts === void 0 ? void 0 : posts.length))
        return _jsx(EmptyState, {}, void 0);
    return (_jsx(GenericPostList, { posts: posts, view: view, context: "member", fetchNextPage: fetchNextPage, hasNextPage: hasNextPage, isLoading: isLoading, isFetched: isFetched, isFetchingNextPage: isFetchingNextPage }, void 0));
};
//# sourceMappingURL=MemberPostList.js.map